<template>
  <div
    class="container"
    style="padding:0; flex-direction:column;display:flex; justify-content: center; align-items: center;"
  >
    <vue-topprogress ref="topProgress"></vue-topprogress>
    <div style="margin: 150px 0;">
      <p style="margin-left: 10px;">Insira seu Código:</p>
      <input style="width: 300px;" v-model="hash" type="text" />
      <i
        class="fas fa-question-circle"
        style="pointer:click; font-size:20px;position:relative; left: 7px; top: -1px;"
        v-b-popover.hover.top="'Insira no campo a sua hash, logo após clique em carregar certificado e aguarde até completar. Logo após clique em gerar certificado e seu certificado será gerado!'"
        title="Como usar?"
      ></i>
    </div>
    <p style="font-weight: 600">{{ msgPartic }}</p>
    <button
      v-if="carregados == true && spinner == false"
      style="margin: 20px; font-size: 30px;"
      class="gerar-btn"
      @click="gerar()"
    >GERAR CERTIFICADO</button>
    <button
      v-if="spinner == true"
      disabled
      style="margin: 20px; font-size: 30px;"
      class="gerar-btn"
    >
      <b-spinner></b-spinner>
    </button>
    <button
      v-if="carregados == false && spinner == false"
      style="margin: 20px; font-size: 30px;"
      class="gerar-btn"
      @click="buscarDados()"
    >CARREGAR CERTIFICADO</button>
    <p
      style="font-style: italic; margin: 0 0 50px 0; font-weight: 500; color: #111111; font-size: 20px"
    >{{erro}}</p>
  </div>
</template>
<script>
import * as jsPDF from 'jspdf';
import api from "../services/api";
export default {
  methods: {
    //CLICK CARREGAR CERTIFICADO
    async buscarDados() {

      if (!this.hash) {
           this.erro = "Por favor, insira um código de certificado.";
           return;
      }

      this.spinner = true;
      this.$refs.topProgress.start();
      this.resultado = await api.getCertificado(this.hash);

      console.log("Resultado do vue: " + this.resultado)
      
        if (this.resultado && (this.resultado.status === 400 || this.resultado.status === 404)) {
           // Ocorreu um erro (retorno do bloco CATCH)
           setTimeout(() => {
           this.$refs.topProgress.fail();
           this.spinner = false;
           this.hash = "";
           this.erro = this.resultado.data.message;
           this.msgPartic = "";
           }, 2000);
           } else if (this.resultado) {
                 // Sucesso (retorno do bloco THEN)
           this.idCurso = this.resultado.idCurso
           setTimeout(() => {
           this.$refs.topProgress.done();
           this.spinner = false;
           this.erro = "";
           this.msgPartic = `Olá ${this.resultado.participante}, Clique no botão abaixo para gerar seu certificado!` 
           this.setaDados();
           }, 2000);
           } else {
        // Caso inesperado
        this.$refs.topProgress.fail();
        this.spinner = false;
        this.erro = "Ocorreu um erro inesperado ao buscar os dados.";
      }
    },
    async setaDados() {
      await this.setaImagens();
      this.carregados = true;
    },
    setaImagens() {
      this.participante = this.resultado.participante;
      this.curso = this.resultado.curso;
      this.instrutor = this.resultado.instrutor;
      this.conteudo = this.resultado.conteudoCertificado;
      this.hashRetornado = this.resultado.hash;
      this.img3.crossOrigin = "";
      this.img3.src ="https://www.cursoslefisc.com.br/certificado/"+this.resultado.coordenadorAssinatura;
      // Removida a lógica de imagem do instrutor (img4)
    },
    //CLICK GERAR CERTIFICADO
    gerar() {
      this.spinner = true;
      this.$refs.topProgress.start();
      setTimeout(this.criaPDF, 2000);
    },
    async criaPDF() {
      this.j = 41;
      this.y = 41;
      this.z = 41;
      console.log('vindoo')
      
      //criando o pdf
      
      var pdf = new jsPDF({
        orientation: "landscape",
        format: "A4"
      });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const imageWidth = 80; // Largura da sua imagem

      // === INÍCIO DAS MODIFICAÇÕES PARA CENTRALIZAÇÃO ===
      
      // Coordenada central da página no modo landscape (297mm / 2 = 148.5)
      const centroPaginaX = pageWidth / 2; // 148.5
      const larguraLinha = 120; // Largura da linha da assinatura (Ex: 120mm)
      const inicioLinhaX = centroPaginaX - (larguraLinha / 2); // 148.5 - 60 = 88.5
      const imagemAssinaturaLargura = 65; // Largura atual da sua imagem (img3)
      const xAssinatura = centroPaginaX - (imagemAssinaturaLargura / 2); // 148.5 - 32.5 = 116

      // === FIM DAS VARIÁVEIS DE CENTRALIZAÇÃO ===


      // Calcula a posição X para centralizar horizontalmente (Essa linha não é mais necessária para assinatura)
      const x = (pageWidth - imageWidth) / 2; 

      //setando grossura da linha
      pdf.setLineWidth(0.6);
      
      // CRIANDO A ÚNICA LINHA CENTRALIZADA (substitui as duas pdf.line)
      pdf.line(inicioLinhaX, 175, inicioLinhaX + larguraLinha, 175);
      
      //setando tamanho para quebrar linha do texto (260)
      var textSplit = pdf.splitTextToSize(
        `Certificamos que ${this.resultado.participante} concluiu o curso ${this.resultado.curso} ministrado por ${this.resultado.instrutor}`,
        260
      );
      //criando o texto setado a cima
      pdf.text(20, 100, textSplit);
      
      //criando textos da carga horaria e cidade
      pdf.text(20, 135, `Carga Horária: ${String(this.resultado.cargaHoraria)}`);
      pdf.text(
        20,
        145,
        `${String(this.resultado.cidade)}, ${String(this.resultado.dataExtenso)}`
      );
      
      // CRIANDO NOMES DO COORDENADOR/TÍTULO ALINHADO NO CENTRO
      pdf.text(String(this.resultado.coordenador), centroPaginaX, 182, null, null, "center");
      pdf.setTextColor(40);
      pdf.setFontSize(14);
      pdf.text("Coordenadora do Curso", centroPaginaX, 187, null, null, "center");
      pdf.setTextColor(0);
      pdf.setFontSize(16);
      
      // REMOVIDOS OS TEXTOS E TÍTULOS DO INSTRUTOR
      
      // CRIANDO TEXTO DA HASH ALINHADO NO CENTRO
      pdf.setTextColor(80);
      pdf.setFontSize(10);
      pdf.text(centroPaginaX, 199, String(this.resultado.hash), null, null, "center");
      
      //adicionando imagens     
      console.log(this.img,this.img2, this.img3)

      pdf.addImage(this.img, 0, 0, 295, 210);
      if(this.idCurso != 3371){
        pdf.addImage(this.img2, 205, 20, 65, 13);
      }
      
      // ADICIONANDO IMAGEM DA ASSINATURA NO CENTRO (usando xAssinatura)
      pdf.addImage(this.img3, xAssinatura, 145, imagemAssinaturaLargura, 45);
      
      // REMOVIDA A IMAGEM DO INSTRUTOR (img4)
      
      if(this.idCurso == 3371){
        //pdf.addImage(this.imgExtra, x-6, 18, imageWidth, 26);
        pdf.addImage(this.imgExtra, 190, 16, 80, 30);
      }
      
      //criando segunda folha (verso)
      pdf.addPage();
      pdf.addImage(this.img5, 0, 0, 300, 210);
      if(this.idCurso != 3371){
        pdf.addImage(this.img2, 9.6, 13, 62.2, 12);
      }
      
      
      
      
      //criando texto do titulo
      pdf.setFontSize(14);
      pdf.text(
        228,
        12,
        `${String(this.resultado.codigoCurso)} - ${String(this.resultado.pontuacao)}`
      );
      pdf.text(228, 18, String(this.resultado.capacitadora));
      pdf.setFontSize(10);
      pdf.text(160, 33, `LEFISC - LEGISLAÇÃO FISCAL   -  `);
      pdf.text(215, 33, `    CNPJ 08.297.075/0001-98`);
      pdf.setTextColor(0);
      pdf.setFontSize(22);
      pdf.text(10, 35, "CONTEÚDO PROGRAMÁTICO");
      
      //criando os itens do conteudo
      pdf.setFontSize(8);
      pdf.setFontType("bold");
      if (this.conteudo && this.conteudo.length > 1 && Array.isArray(this.conteudo)) {
        for (var i = 0; i < this.conteudo.length; i++) {
          const itemText = String(this.conteudo[i].item); // Garante que o item é uma string
          if (i >= 96) {
            pdf.text(210, this.z, itemText);
            this.z += 3.5;
          } else if (i >= 48) {
            pdf.text(110, this.y, itemText);
            this.y += 3.5;
          } else {
            pdf.text(10, this.j, itemText);
            this.j += 3.5;
          }
        }
      }
      
      //salva o certificado
      await pdf.save(
        "certificado.pdf",
        (this.spinner = false),
        this.$refs.topProgress.done(),
        this.carregados = false,
        this.hash = '',
        this.msgPartic = 'Seu certificado foi gerado, parabéns!'
      );
    },  
  },
  computed: {},
  watch: {},
  data() {
    return {
      idCurso:0,
      img: new Image(),
      img2: new Image(),
      img3: new Image(),
      img4: new Image(),
      img5: new Image(),
      imgExtra: new Image(),
      hash: "",
      resultado: [],
      spinner: false,
      participante: "",
      instrutor: "",
      curso: "",
      erro: "",
      conteudo: [],
      hashRetornado: "",
      carregados: false,
      msgPartic: "",
      status:0,
      j: 41,
      y: 41,
      z: 41
    };
  },

  async created() {
    this.hash = this.$route.params.hash;
    this.img.crossOrigin = "";
    this.img.src =
      "https://www.cursoslefisc.com.br/certificado/certificado/IMG/certificado_novo.png";
    this.img2.crossOrigin = "";
    this.img2.src =
      "https://www.cursoslefisc.com.br/certificado/certificado/IMG/logoead.png";
    this.img5.crossOrigin = "";
    this.img5.src =
      "https://www.cursoslefisc.com.br/certificado/certificado/IMG/traseira.jpg";
      this.imgExtra.crossOrigin = "";
    this.imgExtra.src =
      "https://www.cursoslefisc.com.br/certificado/certificado/IMG/CRCES.png";

      if (this.hash) {
      this.buscarDados();
    }
  },
  mounted() {}
};
</script>

<style>
* {
  font-family: "Segoe UI";
}

.gerar-btn {
  width: 70%;
  height: 110px;
  background: #444e67;
  color: #fff;
  font-size: 40px;
  font-weight: 700;
  border-radius: 5px;
  margin-bottom: 45px;
  transition: all 0.2s ease;
}

.gerar-btn:active {
  transform: scale(0.98);
}

input {
  width: 370px;
  height: 38px;
  background: 0% 0% no-repeat padding-box padding-box rgb(255, 255, 255);
  border: 1px solid rgb(187, 187, 187);
  border-radius: 5px;
}
</style>